// extracted by mini-css-extract-plugin
module.exports = {"roomList":"_6c75f7dd","room":"_a7ba7d9f","roomHeader":"_762be60","roomLink":"_27ffabbf","roomTitle":"_f9a6047f","roomImage":"_e4153b8","shimmerLoadingBackground":"_4f627c8d"};